var _clipPath, _clipPath2, _clipPath3, _clipPath4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 0h-400v300h400z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m439.996 300h-399.996v179.996h399.996z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m439.996 300h-399.996v179.996h399.996z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 50c0-27.6133-22.387-50-50-50h-300c-27.6133 0-50 22.3867-50 50v380c0 27.613 22.3867 50 50 50h239.996l110.004-110z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.13333333 0 0 -.13333333 0 64)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90 5c-24.8164 0-45 20.1875-45 45v380c0 24.816 20.1836 45 45 45h237.926l107.074-107.07v-317.93c0-24.8125-20.187-45-45-45z",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.996 480h-239.996c-27.6133 0-50-22.387-50-50v-380c0-27.6133 22.3867-50 50-50h300c27.613 0 50 22.3867 50 50v320zm-4.141-10 104.145-104.141v-315.859c0-22.0547-17.945-40-40-40h-300c-22.0547 0-40 17.9453-40 40v380c0 22.055 17.9453 40 40 40z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90 5c-24.8164 0-45 20.1875-45 45v380c0 24.816 20.1836 45 45 45h237.926l107.074-107.07v-317.93c0-24.8125-20.187-45-45-45z",
    fill: "#f78852"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.996 480h-239.996c-27.6133 0-50-22.387-50-50v-380c0-27.6133 22.3867-50 50-50h300c27.613 0 50 22.3867 50 50v320zm-4.141-10 104.145-104.141v-315.859c0-22.0547-17.945-40-40-40h-300c-22.0547 0-40 17.9453-40 40v380c0 22.055 17.9453 40 40 40z",
    fill: "#e27140"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m344.352 384.973 96.793-96.793v96.793z",
    fill: "#e27140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440 370h-60c-27.613 0-50 22.387-50 50v60h110z",
    fill: "#fbc4a8"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m108.281 407.328v-14.765h4.832c2.082 0 3.86.746 5.344 2.242 1.477 1.492 2.219 3.265 2.219 5.316 0 2.344-.836 4.16-2.508 5.449-1.668 1.289-4.043 1.934-7.117 1.934zm-12.1716 10.371h19.7306c5.305 0 9.582-1.547 12.832-4.633 3.254-3.093 4.879-7.156 4.879-12.199 0-3.308-.801-6.453-2.399-9.422-1.597-2.976-4.004-5.195-7.226-6.66-3.223-1.465-5.977-2.226-8.262-2.285l-7.207-.176v-22.324h-12.3476z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.051 407.328v-14.765h4.832c2.082 0 3.859.746 5.344 2.242 1.472 1.492 2.214 3.265 2.214 5.316 0 2.344-.836 4.16-2.503 5.449-1.668 1.289-4.043 1.934-7.122 1.934zm-12.172 10.371h19.73c5.301 0 9.579-1.547 12.832-4.633 3.25-3.093 4.875-7.156 4.875-12.199 0-3.308-.796-6.453-2.394-9.422-1.598-2.976-4.004-5.195-7.227-6.66-3.222-1.465-5.976-2.226-8.261-2.285l-7.207-.176v-22.324h-12.348z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.426 417.699h38.804v-12.258h-13.226v-45.441h-12.438v45.441h-13.14z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e0e0e0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m230 80c-38.66 0-70 31.34-70 70 0 35.258 26.09 64.34 60 69.203v30.293c-50.531-5.019-90-47.641-90-99.496 0-55.2305 44.77-100 100-100 51.855 0 94.477 39.4688 99.496 90h-30.293c-4.863-33.91-33.945-60-69.203-60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240 160v59.203c-3.277.469-6.598.797-10 .797s-6.723-.328-10-.797v-59.203z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230 220c3.402 0 6.723-.328 10-.797v30.293c-3.289.328-6.625.504-10 .504s-6.711-.176-10-.504v-30.293c3.277.469 6.598.797 10 .797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240 140h59.203c.469 3.277.797 6.598.797 10s-.328 6.723-.797 10h-59.203z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.496 160h-30.293c.469-3.277.797-6.598.797-10s-.328-6.723-.797-10h30.293c.328 3.293.504 6.625.504 10s-.176 6.711-.504 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220 140h20v20h-20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280 200v47.063c22.566-6.719 40.344-24.497 47.063-47.063zm77.992 0c-7.953 39.18-38.812 70.039-77.992 77.992-6.465 1.309-13.148 2.008-20 2.008v-30-50-20h20 50 30c0 6.852-.699 13.535-2.008 20"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.c0e210a104eb52a8e30fc795fa525d84.svg";
export { ForwardRef as ReactComponent };